// 【公共组件】意见与反馈
export default {
    'feedback.name': '意见反馈',
    'feedback.upload': '上传图片',
}
 